import React, { useState } from "react";
import "../css/StaticForm.css";
import AboutTab from "./about.js";
import HowToTab from "./howToTab.js";
import SmartphoneTab from "./smartphoneTab.js";
import badgesTab from "./badgesTab.js";
import { useLanguage } from "../components/Language.js";

function StaticForm({ onClose }) {

  const {language} = useLanguage();
  
  const [currentTab, setCurrentTab] = useState("history");
  //const [language, setLanguage] = useState("en");
  
  const tabComponents = {
    history: {
      component: AboutTab,
      labels: { en: "What is Gaelic Connect?", gd: "Dè th’ ann an Ceangal Gàidhlig?" },
    },
    usage: {
      component: HowToTab,
      labels: { en: "How to Use Gaelic Connect?", gd: "Mar a Chleachdar Ceangal Gàidhlig?" },
    },
    mission: {
      component: SmartphoneTab,
      labels: { en: "Using Gaelic Connect on Your Smartphone", gd: "Cleachdadh Ceangal Gàidhlig air Clis-fòn" },
    },
    culture: {
      component: badgesTab,
      labels: { en: "Earning Badges", gd: "Cosnadh Bràistean" },
    },
  };

  const handleTabChange = (tab) => {
    setCurrentTab(tab);
  };

  //const toggleLanguage = () => {
    //setLanguage((current) => (current === "en" ? "gd" : "en"));
  //};

  const ActiveTabComponent = tabComponents[currentTab].component;

  return (

    <div >
      <div className="tab-header">
        <div className="tabs">
          {Object.keys(tabComponents).map((tabKey) => (
            <button
              key={tabKey}
              className={`btn btn-sm btn-info m-1 tab-button ${currentTab === tabKey ? "active" : ""}`}
              onClick={() => handleTabChange(tabKey)}
            >
              {tabComponents[tabKey].labels[language]}
            </button>
          ))}
        </div>
        <button className= "close-x" onClick={onClose}>&times;</button> 
      </div>

      <div className="tab-content">
        <ActiveTabComponent language={language} />
      </div>

      <div className="modal-footer">
        <button className="close-button GCPillbutton" onClick={onClose}>
        {language === "en" ? "Close" : "Dùin"}
        </button>
      </div>
    </div>

  );
}

export default StaticForm;
